import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { vendorFields } from './common/vendorFields';
import { msg } from '@lingui/core/macro';
import { cryptoRelationshipField } from './common/cryptoFields';

export const cryptoTransactionsMetadata = {
  displayName: msg({
    message: 'Crypto transactions',
    context: 'Activity data schema name for crypto transactions ',
  }),
  fields: {
    ...coreFields,
    ...vendorFields,
    crypto_relationship: cryptoRelationshipField,
    crypto_transaction_count: {
      displayName: msg({
        message: 'Number of transactions',
        context:
          'The number of distinct transactions of cryptocurrency performed.',
      }),
    },
    crypto_transaction_fee_quantity: {
      displayName: msg({
        message: 'Transaction fee',
        context: 'The fee paid for conducting the transaction.',
      }),
    },
    crypto_transaction_fee_unit: {
      displayName: msg({
        message: 'Transaction fee currency',
        context:
          'The abbreviation of the currency of the fee for the transaction.',
      }),
    },
    crypto_transaction_quantity: {
      displayName: msg({
        message: 'Transaction amount',
        context: 'The quantity of cryptocurrency transacted.',
      }),
    },
    crypto_transaction_unit: {
      displayName: msg({
        message: 'Transaction currency',
        context: 'The abbreviation of the currency of the transaction.',
      }),
    },
  },
} as const satisfies BatMetadataConfigEntry;
